import base from "../baseurl";
import token from "../getTk";

const showAll = async (companyId, sitimmFee, feeAmount) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  console.log(companyId, sitimmFee, feeAmount);
  const show = await api
    .post("weekly-fees/update-company", {
      json: { companyId, sitimmFee, feeAmount },
    })
    .json();
  return show;
};

export default showAll;
